
































import { computed, defineComponent, ref } from "@vue/composition-api";
import { InputReviewSearch, Review, ReviewSubjectType } from "@scrile/api-provider/dist/api/ReviewProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";
import BaseInputBox from "@/components/BaseInputBox";
import BaseSendMessage from "@/components/BaseSendMessage";
import SendMessageController from "@/components/SendMessageController";
import ReviewRemoveConfirm from "./components/ReviewRemoveConfirm.vue";
import ReviewsFullListController from "./components/ReviewsFullListController.vue";
import ReviewsItem from "./components/ReviewsItem.vue";
import ReviewsSendController from "./components/ReviewsSendController.vue";

const REVIEW_COUNT_LIMIT = 3;

export default defineComponent({
  name: "FeedReviews",
  components: {
    ReviewRemoveConfirm,
    BaseConfirm,
    BaseButton,
    ReviewsFullListController,
    ReviewsSendController,
    ReviewsItem,
    BaseSendMessage,
    BaseInputBox,
    BaseIcon,
    SendMessageController,
  },
  props: {
    isAuthor: { type: Boolean, default: false },
    postId: { type: String, required: true },
    reviewStatsCount: { type: Number, required: true },
  },
  setup(props, { emit }) {
    const { authUserStrict } = useAuthUser();
    const reviews = ref<Review[]>([]);
    const loading = ref(false);
    const showModal = ref(false);
    const showConfirm = ref(false);
    const removeReviewId = ref("");
    emit("modal-cb:show", () => (showModal.value = true));

    const manyReviews = computed(() => props.reviewStatsCount > REVIEW_COUNT_LIMIT);

    const preloadReviews = async () => {
      try {
        loading.value = true;
        const data: InputReviewSearch = {
          subjects: [
            {
              subjectId: props.postId,
              subjectType: ReviewSubjectType.POST,
            },
          ],
          size: REVIEW_COUNT_LIMIT,
          sort: "TIME,DESC",
        };
        const response = await providers.ReviewProvider.find({ data });
        reviews.value = response.result;
      } finally {
        loading.value = false;
      }
    };
    preloadReviews();

    const onAddReview = (r: Review) => {
      emit("update:countReview", props.reviewStatsCount + 1);
      reviews.value.unshift(r);
      if (reviews.value.length > REVIEW_COUNT_LIMIT) {
        reviews.value.pop();
      }
    };

    const showRemoveConfirm = (id: string) => {
      showConfirm.value = true;
      removeReviewId.value = id;
    };

    const onRemoveReviewCb = (id: string) => {
      emit("update:countReview", props.reviewStatsCount - 1);
      reviews.value = reviews.value.filter(r => r.id !== id);
      showConfirm.value = false;
    };

    const toggleModal = () => {
      showModal.value = !showModal.value;
    };

    return {
      reviews,
      showModal,
      toggleModal,
      manyReviews,
      onAddReview,
      onRemoveReviewCb,
      authUserStrict,
      showConfirm,
      showRemoveConfirm,
      removeReviewId,
    };
  },
});
